import type { KeyboardType } from './keyboard-types';
import type { PropType } from 'virtual-vue';

/**
 * 组件的props
 */
export const props = {
  /**
   * 键盘是否可见
   * @default false
   */
  visible: {
    type: Boolean,
    default: false,
  },

  /**
   * 键盘类型，可选值为 'default'（默认键盘）、'confirm'（带确认按钮的键盘）
   * @default 'default'
   */
  type: {
    type: String as PropType<KeyboardType>,
    default: 'default',
  },

  /**
   * 是否可输入小数点
   * @default false
   */
  decimal: {
    type: Boolean,
    default: false,
  },

  /**
   * 是否启用安全模式
   * @default false
   */
  safeMode: {
    type: Boolean,
    default: false,
  },

  /**
   * 右上角关闭按钮文案
   * @default ''
   */
  closeBtnText: {
    type: String,
    default: '',
  },

  /**
   * 键盘内嵌的确认按钮文案
   * @default 'OK'
   */
  confirmBtnText: {
    type: String,
    default: 'OK',
  },
  /**
   * 是否允许用户点击键盘内嵌的确认按钮进行提交
   * @default false
   */
  confirmBtnEnable: {
    type: Boolean,
    default: false,
  },
};


/**
 * Keyboard单项key组件的props
 */
export const keyProps = {
  /**
   * 键盘键值
   * @default ''
   */
  value: {
    type: String,
    default: '',
  },

  /**
   * 是否启用安全模式
   * @default false
   */
  safeMode: {
    type: Boolean,
    default: false,
  },

  /**
   * 键盘内嵌的确认按钮文案
   * @default 'OK'
   */
  confirmBtnText: {
    type: String,
    default: 'OK',
  },
  /**
   * 是否允许用户点击键盘内嵌的确认按钮进行提交
   * @default false
   */
  confirmBtnEnable: {
    type: Boolean,
    default: false,
  },
};

